import dayjs from "dayjs";

import { parseTimestamp } from "metabase/utils/time-dayjs";

export const isWithinWeeks = (
  timestamp: string,
  weekCount: number,
): boolean => {
  const date = parseTimestamp(timestamp);
  const weeksAgo = dayjs().subtract(weekCount, "week");
  return date.isAfter(weeksAgo);
};

/**
 * MetrioniQ: the homepage lists dashboards only, never questions, models,
 * metrics or tables. See docs/customizations.md.
 */
export const dashboardsOnly = <T extends { model: string }>(items: T[]): T[] =>
  items.filter((item) => item.model === "dashboard");
